'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';
import { IoInformationCircleOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { Icon } from '../../icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../tooltip';

import styles from './FormLabel.module.scss';

type LabelProps = BaseComponentProps & {
  children?: ReactNode;
  info?: ReactNode;
  infoIcon?: ReactNode;
};

function FormLabel({
  style,
  className,
  children,
  info,
  infoIcon,
  testId = 'ui-form-label',
}: LabelProps) {
  return (
    <span
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <h6 className={styles['header']}>{children}</h6>
      {info && (
        <Tooltip placement="top">
          <TooltipTrigger asChild={true}>
            <Icon
              icon={infoIcon || <IoInformationCircleOutline />}
              size="sm"
              className={styles['icon']}
            />
          </TooltipTrigger>
          <TooltipContent className={styles['tooltip-content']}>
            <div className={styles['text']}>{info}</div>
          </TooltipContent>
        </Tooltip>
      )}
    </span>
  );
}

export { FormLabel };
